import { render, staticRenderFns } from "./CodeItems.vue?vue&type=template&id=f4ac2f88&scoped=true"
import script from "./CodeItems.vue?vue&type=script&lang=js"
export * from "./CodeItems.vue?vue&type=script&lang=js"
import style0 from "./CodeItems.vue?vue&type=style&index=0&id=f4ac2f88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ac2f88",
  null
  
)

export default component.exports